module.exports = __webpack_public_path__ + "img/14-5.28059d5f.png";